import React, { useState, useEffect } from 'react'
import {
    Box,
    Button,
    Modal,
    Typography,
    IconButton,
    TextField,
    MenuItem,
    FormControl,
    Select,
    FormHelperText
} from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import CircularProgress from '@mui/material/CircularProgress'
import { useSelector, useDispatch } from 'react-redux'
import ArrowForwardIcon from '@mui/icons-material/ArrowForward'
import CancelIcon from '@mui/icons-material/Cancel'
import {
    Dialog,
    DialogActions,
    DialogContent,
    Grid,
    Autocomplete
} from '@mui/material'
import { getFleetCars } from '../../redux/slices/common'
import FleetData from '../../data/fleets.json'
import FormLabel from '../label'
import CtaButton from '../buttonWithArrow'
import { lockScroll, unlockScroll } from '../../utils/scrollLock'
import DynamicPillButton from '../buttonWithArrow/whatsappButton'
import { countries } from '../../data/countries';
import { getInvestmentEnquiry, imageUpload } from '../../redux/slices/investments'
import AfterFormSubmit from '../investNow/AfterFormSubmit';
import PhoneInput from "../../components/phoneInput";

const pillInputSx = {
    "& .MuiOutlinedInput-root": {
        borderRadius: 999,
        bgcolor: "#fff",
    },
};


const style = {
    modal: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        p: 2,
        backgroundColor: "rgba(0,0,0,0.6)", // dimmed background
    },
    container: {
        position: "sticky",
        top: 0,
        zIndex: 1,
        px: { xs: 2, sm: 3 },
        py: 2,
        borderBottom: "1px solid #eee",
        bgcolor: "#fff",
    },
    header: {
        fontWeight: 700,
        fontSize: 24,
        mb: 2
    },
    closeBtn: { position: "absolute", top: 8, right: 8, width: 36, height: 36 },
    input: {
        width: '100%',
        mb: 2,
        backgroundColor: '#f3f3f3',
        borderRadius: '12px',
        input: {
            padding: '22px 14px'
        },
        '& .MuiFilledInput-root': {
            backgroundColor: '#f3f3f3',
            borderRadius: '12px',
            boxShadow: 'none',
            '&:before': {
                borderBottom: '0 !important' // removes the bottom underline
            },
            '&:after': {
                borderBottom: '0 !important' // removes the focus underline
            },
            '&:hover:before': {
                borderBottom: '0 !important'
            }
        },
        '& .MuiFormHelperText-root': {
            marginLeft: 0
        }
    },
    select: {
        width: '100%',
        mb: 2,
        backgroundColor: '#f3f3f3',
        borderRadius: '12px',

        '& .MuiFilledInput-root': {
            backgroundColor: '#f3f3f3',
            borderRadius: '12px',
            paddingTop: '12px',
            paddingBottom: '12px',
            '&:before, &:after, &:hover:before': {
                borderBottom: '0 !important'
            }
        },
        '& .MuiSelect-filled': {
            padding: '12px 14px',
            backgroundColor: '#f3f3f3'
        }
    },
    submitBtn: {
        background: 'linear-gradient(to right, #9CD0C9, #32788E)',
        color: '#fff',
        fontWeight: 600,
        borderRadius: '12px',
        fontSize: '16px',
        textTransform: 'none',
        mt: 2,
        py: 1.2
    },
    fileInputBox: {
        display: "flex",
        alignItems: "center",
        gap: 1.5,
        // bgcolor: "#f3f3f3",
        borderRadius: 999,
        px: 2,
        py: 1.5,
        mb: 2,
        border: "1px solid #c4c4c4",
    },
    chooseBtn: {
        background: "linear-gradient(to right, #9CD0C9, #32788E)",
        color: "#fff",
        fontWeight: 600,
        borderRadius: "10px",
        fontSize: 13,
        px: 2,
        py: 0.75,
        textTransform: "none",
        "&:hover": {
            opacity: 0.95,
        },
    },
    fileRemoveBtn: {
        color: "#7bcbc4",
        "&:hover": { color: "#5fbab2" },
    },
}

export default function EnquireFormModal({
    open,
    setOpen,
    onClose,
    fleetCard = []
}) {
    const dispatch = useDispatch()
    const { investEnquiryRes } = useSelector(state => state.investment)
    const { imageRes } = useSelector(state => state.investment)
    const [statusMessage, setStatusMessage] = useState('')
    const [status, setStatus] = useState(null);
    const [enquiryOpen, setEnquiryOpen] = useState(false)
    const [vehicleInfo, setVehicleInfo] = useState([])
    const [loader, setLoader] = useState(false)
    const [imageMessage, setImageMessage] = useState(null);
    const [imageLoader, setImageLoader] = useState(false);
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        countryCode: '971',
        phone: '',
        itemId: "",
        itemInfo: "",
        document: null,
        collaborate: 1
    })

    const [errors, setErrors] = useState({})


    useEffect(() => {
        if (open) lockScroll();
        else unlockScroll();

        return () => unlockScroll(); // cleanup if component unmounts
    }, [open]);

    const handleChange1 = e => {
        const selectedId = e.target.value
        const info = fleetCard?.find((item) => item?._id === selectedId);
        setFormData(prev => ({
            ...prev,
            itemId: selectedId,
            itemInfo: info
        }))
    }

    const resetForm = () => {
        setFormData({
            name: '',
            email: '',
            countryCode: '971',
            phone: '',
            itemId: "",
            itemInfo: "",
            document: null,
            collaborate: 1
        })
        setErrors({})
        setImageMessage(null);
    }

    const handleClickOpen = () => {
        // setOpen(false);
        setEnquiryOpen(true)
    }

    const handleClose = () => {
        // if (statusMessage === "") {
        //     window.location.reload();
        // }
        // resetForm();
        if (statusMessage === '' && status === 1) {
            setOpen(false)
        }
        setEnquiryOpen(false)
    }

    useEffect(() => {
        if (investEnquiryRes) {
            setLoader(false)
            if (investEnquiryRes.status === 1) {
                handleClickOpen()
                resetForm()
                setStatusMessage('')
                setStatus(investEnquiryRes.status);
            } else {
                handleClickOpen()
                setStatus(-1)
                setStatusMessage(investEnquiryRes.message || `We’re sorry! Something went wrong. Please try again in a few moments.`)
            }
        }
    }, [investEnquiryRes])

    const handleFileChange = async (e) => {
        const selectedFile = e.target.files[0];
        setImageMessage(null);
        // Dispatch the upload file action
        if (selectedFile) {
            setImageLoader(true); // Set loader while uploading the file            
            const formData = new FormData();
            formData.append('file', selectedFile);
            formData.append('type', "image");
            // Dispatch the upload action
            dispatch(imageUpload(formData));
        }
    };

    useEffect(() => {
        if (imageRes) {
            setImageLoader(false);
            if (imageRes?.status === 1) {
                setImageMessage(null);
                setFormData({ ...formData, ["document"]: imageRes?.path });
            } else {
                setImageMessage(imageRes?.message);
                setFormData({ ...formData, ["document"]: null });
            }
        }
    }, [imageRes])

    const validate = () => {
        const newErrors = {}
        if (!formData.name.trim()) newErrors.name = 'Name is required'
        else if (!/^[A-Za-z\s]+$/.test(formData.name))
            newErrors.name = 'Only letters and spaces allowed'

        if (!formData.email) newErrors.email = 'Email is required'
        else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email))
            newErrors.email = 'Enter a valid email address'

        if (!formData.phone) newErrors.phone = 'Phone number is required'
        else if (!/^\d{7,15}$/.test(formData.phone))
            newErrors.phone = 'Enter a valid phone number (7–15 digits)'

        if (!formData.itemId) newErrors.type = 'This field is required'

        return newErrors
    }

    const handleSubmit = async e => {
        e.preventDefault()

        const validationErrors = validate()
        setErrors(validationErrors)

        if (Object.keys(validationErrors).length > 0) {
            setStatusMessage('Please fix the errors before submitting.')
            return
        }
        setStatusMessage('')
        setLoader(true)
        dispatch(getInvestmentEnquiry(formData))
    }

    useEffect(() => {
        dispatch(getFleetCars())
    }, [])

    const handleEnquiryClose = () => {
        onClose()
        resetForm()
    }

    return (
        <>
            <Modal
                open={open}
                onClose={handleEnquiryClose}
                sx={style.modal}
                scroll='body'
            >
                {/* Shell */}
                <Box
                    sx={{
                        position: "relative",
                        width: 560,
                        maxHeight: { xs: "90vh", sm: "90vh" },   // <-- controls total modal height
                        bgcolor: "#fff",
                        borderTopLeftRadius: { xs: 12, sm: 16 },
                        borderTopRightRadius: { xs: 12, sm: 16 },
                        borderRadius: { sm: 4 },
                        boxShadow: "0 18px 60px rgba(0,0,0,.25)",
                        display: "flex",
                        flexDirection: "column",
                        overflow: "hidden",
                    }}
                >
                    <Box sx={style.container}>
                        <Typography sx={{ fontWeight: 800, fontSize: { xs: 18, sm: 22, md: 24 } }} className="jura">Enquire</Typography>
                        <IconButton
                            onClick={handleEnquiryClose}
                            sx={style.closeBtn}
                            aria-label="Close"
                        >
                            <CloseIcon />
                        </IconButton>
                    </Box>

                    <Box
                        sx={{
                            px: { xs: 2, sm: 3 },
                            overflowY: "auto",
                            flex: 1,
                            // helps value label of slider not get clipped
                            "&& .MuiSlider-root": { overflow: "visible" },
                        }}
                    >
                        <Grid container spacing={2} sx={{ mt: 0 }}>
                            <Grid item xs={12}>
                                <FormLabel label="Name" required />
                                <TextField
                                    fullWidth
                                    placeholder="Enter Name"
                                    name="name"
                                    value={formData.name}
                                    error={!!errors.name}
                                    helperText={errors.name}
                                    onChange={e => {
                                        const onlyLetters = e.target.value.replace(/[^a-zA-Z\s]/g, '')
                                        setFormData({ ...formData, name: onlyLetters })
                                    }}
                                    sx={pillInputSx}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <FormLabel label="Email" required />
                                <TextField
                                    fullWidth
                                    placeholder='john@example.com'
                                    value={formData.email}
                                    name="email"
                                    error={!!errors.email}
                                    helperText={errors.email}
                                    onChange={e => setFormData({ ...formData, email: e.target.value })}
                                    sx={pillInputSx}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <FormLabel label="Phone" required />
                                <Box sx={{ display: "flex", mb: 2 }}>
                                    {/* Country Code Selector */}
                                    {/* <Autocomplete
                                        disableClearable
                                        options={countries}
                                        getOptionLabel={(option) => `${option.code} (+${option.phone})`}
                                        filterOptions={(options, { inputValue }) =>
                                            options.filter(
                                                (option) =>
                                                    option.label.toLowerCase().includes(inputValue.toLowerCase()) ||
                                                    option.code.toLowerCase().includes(inputValue.toLowerCase()) ||
                                                    option.phone.includes(inputValue.replace("+", ""))
                                            )
                                        }
                                        value={countries.find((c) => c.phone === formData.countryCode) || countries[0]}
                                        onChange={(e, value) => {
                                            if (value) setFormData({ ...formData, countryCode: value.phone });
                                        }}
                                        sx={{
                                            width: "35%",
                                            "& .MuiOutlinedInput-root": {
                                                borderRadius: "999px 0 0 999px",
                                            },
                                        }}
                                        renderOption={(props, option) => (
                                            <li {...props}>
                                                <span style={{ marginRight: 8 }}>
                                                    {String.fromCodePoint(
                                                        ...[...option.code.toUpperCase()].map((c) => 127397 + c.charCodeAt())
                                                    )}
                                                </span>
                                                {option.code} (+{option.phone})
                                            </li>
                                        )}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                variant="outlined"
                                                sx={{
                                                    "& .MuiOutlinedInput-root": {
                                                        borderRadius: "999px 0 0 999px",
                                                    },
                                                }}
                                            />
                                        )}
                                    /> */}

                                    {/* Phone Number Input */}
                                    {/* <TextField
                                        fullWidth
                                        placeholder="Enter Phone"
                                        value={formData.phone}
                                        name="phone"
                                        onChange={e =>
                                            setFormData({
                                                ...formData,
                                                phone: e.target.value.replace(/\D/g, '')
                                            })
                                        }
                                        error={!!errors.phone}
                                        helperText={errors.phone}
                                        sx={{
                                            "& .MuiOutlinedInput-root": {
                                                borderRadius: "0 999px 999px 0", // rounded right side
                                                bgcolor: "#fff",
                                            }
                                        }}
                                    /> */}


                                    <PhoneInput
                                        value={formData.phone}
                                        countryCode={formData.countryCode}
                                        onChange={(countryCode, phone) =>
                                            setFormData((prev) => ({
                                                ...prev,
                                                countryCode,
                                                phone,
                                            }))
                                        }
                                        error={!!errors.phone}
                                        helperText={errors.phone}
                                        width="100%"
                                    />

                                </Box>
                            </Grid>
                            <Grid item xs={12}>
                                <FormLabel label="Select Business" required />
                                <FormControl fullWidth error={!!errors.type} sx={{ ...pillInputSx, "& fieldset": { borderRadius: 999 } }}>
                                    <Select
                                        displayEmpty
                                        value={formData.itemId}
                                        name="type"
                                        onChange={handleChange1}
                                        renderValue={(selected) => {
                                            if (!selected) {
                                                return <span style={{ color: "#808890" }}>Select Business</span>;
                                            }
                                            const selectedItem = fleetCard?.find((item) => item?._id === selected);
                                            return selectedItem ? selectedItem?.name : "";
                                        }}
                                    >
                                        {fleetCard?.map((item) => (
                                            <MenuItem key={item?._id} value={item?._id}>
                                                {item?.name}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                    <FormHelperText>{errors.type ? errors.type : " "}</FormHelperText>
                                </FormControl>
                            </Grid>

                            <Grid item xs={12}>
                                <FormLabel label="Document" />
                                <Box
                                    sx={{
                                        border: "1px solid #E5E5E5",
                                        borderRadius: "27px",
                                        p: 2,
                                        textAlign: "center",
                                        mb: 2,
                                    }}
                                >
                                    <input
                                        id="document-upload"
                                        type="file"
                                        hidden
                                        accept="image/*,.pdf"
                                        disabled={imageLoader}
                                        onChange={(e) => handleFileChange(e)}
                                    />
                                    {!formData.document ? (
                                        <label htmlFor="document-upload" style={{ cursor: "pointer" }}>
                                            <Box
                                                sx={{
                                                    display: "flex",
                                                    flexDirection: "column",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    gap: 1,
                                                }}
                                            >
                                                {
                                                    imageLoader ? <CircularProgress
                                                        sx={{
                                                            width: "20px !important",
                                                            height: "20px !important",
                                                            color: "#0f7f8a",
                                                        }}
                                                    /> :
                                                        <img
                                                            src="/img/investments/limousine/upload.svg"
                                                            alt="upload"
                                                            width={60}
                                                        />
                                                }
                                                <Typography
                                                    color="#2A7B8F"
                                                    sx={{
                                                        fontSize: 13,
                                                        fontWeight: 500,
                                                        textDecoration: "underline",
                                                    }}
                                                >
                                                    Click here to upload your file.
                                                </Typography>
                                                {
                                                    imageMessage ? <Typography color="red" sx={{ fontSize: 12 }}>
                                                        {imageMessage}
                                                    </Typography> : <Typography color="#A0A0A0" sx={{ fontSize: 12 }}>
                                                        Supported Format:  JPG, PNG
                                                    </Typography>
                                                }
                                            </Box>
                                        </label>
                                    ) : (
                                        <Box
                                            sx={{
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "space-between",
                                                px: 2,
                                            }}
                                        >
                                            <Typography
                                                sx={{
                                                    fontSize: 14,
                                                    color: "#333",
                                                    textAlign: "left",
                                                    overflow: "hidden",
                                                    textOverflow: "ellipsis",
                                                    whiteSpace: "nowrap",
                                                    maxWidth: "80%",
                                                }}
                                                title={formData.document}
                                            >
                                                {formData.document}
                                            </Typography>

                                            <IconButton
                                                size="small"
                                                onClick={() => setFormData({ ...formData, document: null })}
                                            >
                                                <CancelIcon fontSize="small" sx={{ color: "#7bcbc4" }} />
                                            </IconButton>
                                        </Box>
                                    )}
                                </Box>
                            </Grid>

                        </Grid>

                        {/* Footer (sticky) */}
                        <Box
                            sx={{
                                position: "sticky",
                                bottom: 0,
                                zIndex: 1,
                                px: { xs: 2, sm: 3 },
                                py: { xs: 2, sm: 2 },
                                borderTop: "1px solid #eee",
                                bgcolor: "#fff",
                                display: "flex",
                                justifyContent: "flex-end",
                                gap: "16px",
                                justifyContent: "end",
                                flexDirection: { xs: "column", sm: "row" }
                            }}
                        >
                            <CtaButton label="Submit" onClick={handleSubmit}
                                loader={loader}
                            //  disabled={!isValid}
                            />
                            {/* <DynamicPillButton
                                label="Send a message"
                                icon="/img/header/whatsapp.svg"
                                iconPosition="end"
                                bg="#25D366"
                                // onClick={onWhatsapp}
                                size="md"
                                sx={{ height: "47px !important" }}
                            /> */}
                        </Box>
                    </Box>
                </Box>
            </Modal>

            <AfterFormSubmit open={enquiryOpen} status={status} message={statusMessage} onClose={handleClose} Catalog={statusMessage === ""} />

        </>
    )
}
